module.exports = __webpack_public_path__ + "img/img-only.a3bd856c.jpg";